import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import Vulnerabilities from "./Vulnerabilities";
const VulnerabilitiesTab = () => {
    return (React.createElement(ErrorBoundary, { key: "vulnerabilities" },
        React.createElement(Vulnerabilities, null)));
};
export default VulnerabilitiesTab;
//# sourceMappingURL=VulnerabilitiesTab.js.map